import { VF_DROPDOWN } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  ZERO_MIN_BUS_CRITICAL_UP_TO_1HR_NON,
  LESS_THAN_1HR_BUS_CRITICAL_1_4HR_NON,
  ONE_HR_BUS_CRITICAL_MORE_THAN_4HR_NON,
  NO_OUTAGE,
} from 'AppSrc/core/components/forms/value-dependency-constants';



const fieldId = 'service-outage-duration';

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_DROPDOWN);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an answer' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};


const initialValues = null;

const vFParams = {
  fieldTitle: 'What is the service outage duration?',
  placeholder: 'Please select',
};


const riskLevelParams = {
  weight: 1,
  score: {
    [ZERO_MIN_BUS_CRITICAL_UP_TO_1HR_NON]: 5,
    [LESS_THAN_1HR_BUS_CRITICAL_1_4HR_NON]: 5,
    [ONE_HR_BUS_CRITICAL_MORE_THAN_4HR_NON]: 5,
    [NO_OUTAGE]: 1,
  },
};


const serviceOutageDuration = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  riskLevelParams,
  fieldType: VF_DROPDOWN,
};

export { serviceOutageDuration };
